module.exports = "<section style=\"margin:0 auto\"\r\n    max-width=\"lg\">\r\n  <empresas-lista></empresas-lista>\r\n</section>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/empresas/components/template.html
// module id = 2434
// module chunks = 0